if (!customElements.get('tabbed-section')) {
    customElements.define('tabbed-section', class TabbedSection extends HTMLElement {
      constructor() {
        super();
        this.tabLinks = this.querySelectorAll('.tab-a');
        this.tabHeaders = this.querySelectorAll('.tab h3');
        
        this.init();
      }
      init() {
        this.tabLinks.forEach(tabLink => {
          tabLink.addEventListener('click', this.handleTabClick.bind(this));
        });
        this.tabHeaders.forEach(header => {
          header.addEventListener('click', this.handleHeaderClick.bind(this));
        });
      }
      handleTabClick(event) {
        event.preventDefault();
        
        // Remove 'tab-active' class from all tabs
        this.querySelectorAll('.tab').forEach(tab => {
          tab.classList.remove('tab-active');
        });
        // Add 'tab-active' class to the clicked tab
        const dataId = event.target.getAttribute('data-id');
        const activeTab = this.querySelector(`.tab[data-id='${dataId}']`);
        if (activeTab) {
          activeTab.classList.add('tab-active');
        }
        // Remove 'active-a' class from all tab links
        this.tabLinks.forEach(link => {
          link.classList.remove('active-a');
        });
        // Add 'active-a' class to the clicked tab link
        event.target.classList.add('active-a');
      }
      handleHeaderClick(event) {
        const tab = event.target.parentElement;
        if (tab.classList.contains('tab-active')) {
          tab.classList.remove('tab-active');
        } else {
          // Remove 'tab-active' class from all tabs
          this.querySelectorAll('.tab').forEach(tab => {
            tab.classList.remove('tab-active');
          });
          tab.classList.add('tab-active');
        }
      }
    });
  }